import React from 'react';

import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { theme, Illustration } from 'fpay-ui';

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  align-items: center;
`;

const ModalImage = styled(Illustration)`
  width: 180px;
  height: 180px;
  margin-top: 2px;
`;
const ModalTextHeader = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['H6-w400']}
    line-height: 1.2;
    text-align: center;
    margin-top: 0px;
    color: ${theme.colors.gray800};
    letter-spacing: normal;
  `
);

const ModalTextBody = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Body-2-w400']}
    line-height: 1.43;
    text-align: center;
    margin-top: 14px;
    margin-bottom: 8px;
    min-width: 274px;
    color: ${theme.colors.gray700};
    max-width: 267px;
    ${theme.breakpoint('md')} {
      min-width: 300px;
    }
  `
);

const ModalButtonOk = styled.div`
  ${theme.textTypes['Body-2-w400']}
  text-align: center;
  line-height: normal;
  color: ${theme.colors.white};
  width: 100%;
  max-width: 274px;
  padding-top: 10px;
  padding-bottom: 9px;
  justify-content: center;
  font-size: 14px;
  margin-top: 30px;
  margin-bottom: 32px;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${theme.colors.gbrand500};
  transition: all 0.3s ease 0s;
  ${theme.breakpoint('md')} {
    width: 136px;
    padding-top: 14px;
    padding-bottom: 16px;
    margin-bottom: 30px;
    margin-top: 16px;
    font-size: 16px;
  }
  &:hover {
    box-shadow: 0 1px 6px rgb(32 33 36 / 28%);
    background-color: ${theme.colors.gbrand600};
  }
  &:active {
    border: 1px solid ${theme.colors.gbrand500};
  }
`;

const ErrorConectionModal = ({ fClose }) => {
  const { t } = useTranslation();

  return (
    <ModalContainer>
      <ModalImage name="error_conection" alt="Ayuda" />
      <ModalTextHeader>{t('errorConection.modal.header')}</ModalTextHeader>
      <ModalTextBody>{t('errorConection.modal.text')}</ModalTextBody>
      <ModalButtonOk onClick={fClose} testId="onClickIcon">
        {t('common.understand')}
      </ModalButtonOk>
    </ModalContainer>
  );
};

export default ErrorConectionModal;
